/* Keep Shrine's bundle/subscription submission intact, but give it a cart
 * destination before AfterSell's asynchronous theme integration is ready. */
(() => {
  let opening;
  let notice;
  const adapters = new WeakMap();

  function showNotice(message, retry = false) {
    if (!notice) {
      notice = document.createElement('div');
      notice.setAttribute('role', 'status');
      notice.className = 'aftersell-cart-bridge-notice';
      Object.assign(notice.style, {
        position: 'fixed', bottom: '24px', left: '16px', right: '16px',
        zIndex: '2147483647', padding: '16px', background: '#fff',
        color: '#222', boxShadow: '0 4px 24px #0003', borderRadius: '8px'
      });
      document.body.appendChild(notice);
    }
    notice.textContent = message;
    if (retry) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button';
      button.textContent = 'Open cart';
      button.addEventListener('click', () => openCart());
      notice.append(' ', button);
    }
  }

  function waitForCart() {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        clearInterval(poll);
        reject(new Error('AfterSell cart did not become ready'));
      }, 15000);
      const poll = setInterval(check, 50);
      let waiting = false;
      function check() {
        const cart = window.aftersell?.cart;
        if (waiting || typeof cart?.ready !== 'function'
          || typeof cart.actions?.refresh !== 'function'
          || typeof cart.actions?.open !== 'function') return;
        waiting = true;
        Promise.resolve().then(() => cart.ready()).then(() => {
          clearTimeout(timeout);
          clearInterval(poll);
          resolve(cart);
        }, error => {
          clearTimeout(timeout);
          clearInterval(poll);
          reject(error);
        });
      }
      check();
    });
  }

  function openCart() {
    if (opening) return opening;
    showNotice('Loading your cart…');
    opening = waitForCart().then(async cart => {
      // Open even if a refresh fails: never repeat the successful add or
      // navigate away from the product page to recover a drawer failure.
      try {
        await cart.actions.refresh();
      } catch (error) {
        console.warn('AfterSell cart refresh failed', error);
      }
      await cart.actions.open();
      notice?.remove();
      notice = null;
    }).catch(() => {
      showNotice('Your cart is taking longer to load. Please try opening it again.', true);
    }).finally(() => { opening = null; });
    return opening;
  }

  function prepare(form) {
    // This site uses AfterSell. Prepare even before its async root is inserted.
    // Preserve explicit Buy now / skip-cart checkout behavior.
    if (form.querySelector('[name="id"][data-skip-cart="true"]')) return;
    let adapter = adapters.get(form);
    if (!adapter) {
      adapter = document.createElement('div');
      adapter.getSectionsToRender = () => [{ id: 'cart-icon-bubble' }];
      adapter.setActiveElement = () => {};
      adapter.renderContents = () => openCart();
      adapters.set(form, adapter);
    }
    form.cart = adapter;
  }

  const prepareAll = () => document.querySelectorAll('product-form').forEach(prepare);
  // Registered before the theme and app listeners. Sticky and bundle buttons
  // can call handleSubmit directly instead of dispatching a form submit.
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('product-form, sticky-atc, [id^="SectionAtcBtn-"]')) prepareAll();
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey
      || event.metaKey || event.shiftKey || event.altKey || link.hasAttribute('download')
      || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, window.location.href);
    const cartUrl = new URL(window.routes?.cart_url || '/cart', window.location.origin);
    if (destination.origin !== cartUrl.origin || destination.pathname.replace(/\/$/, '') !== cartUrl.pathname.replace(/\/$/, '')
      || destination.search || destination.hash) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openCart();
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target.closest?.('product-form');
    if (!form) return;
    // Before the deferred theme defines product-form, a native submit would
    // navigate to the old cart. Cancel it, then submit exactly once when the
    // theme's bundle/quantity/subscription handler is available.
    if (!customElements.get('product-form')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.aftersellPendingSubmit === 'true') return;
      form.dataset.aftersellPendingSubmit = 'true';
      showNotice('Loading purchase options…');
      const nativeForm = event.target;
      const submitter = event.submitter;
      customElements.whenDefined('product-form').then(() => {
        delete form.dataset.aftersellPendingSubmit;
        if (!nativeForm.isConnected) return;
        prepare(form);
        if (!submitter || (submitter.form === nativeForm && !submitter.disabled)) {
          nativeForm.requestSubmit(submitter || undefined);
        }
        // Cart loading has its own notice after a successful add. Do not leave
        // a loading notice over stock or validation errors from the theme.
        if (!opening) { notice?.remove(); notice = null; }
      });
      return;
    }
    prepare(form);
  }, true);
  customElements.whenDefined('product-form').then(prepareAll);
})();
